import * as React from 'react'
function SvgDocument(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M36 4v26c0 3.4-2.6 6-6 6H10c-3.4 0-6-2.6-6-6v-8h8V4h24zm-4 4H16v24h14c1.2 0 2-.8 2-2V8zm-4 14v4h-8v-4h8zm0-8v4h-8v-4h8z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgDocument
